import request from '../../../../../api/request';

import { RateBasis } from '../shared/rateConversion';

const BASE = '/maintainers-portal/financial-portal/settings/late-interest';

export interface LateInterestRateItem {
  id: number;
  rate: number;
  rateBasis: RateBasis;
  monthlyRate: number;
  dailyRate: number;
  graceDays: number;
  validFrom: string;
  /** Rige hoy. */
  isActive: boolean;
  /** Su fecha de inicio aún no llega, así que se puede editar o eliminar. */
  isEditable: boolean;
}

export type AccrualBase = 'totalResidual' | 'capitalOnly';

export interface LateInterestOverview {
  rateBasis: RateBasis;
  base: AccrualBase;
  items: LateInterestRateItem[];
}

export interface LateInterestPayload {
  rate: number;
  graceDays: number;
  validFrom: string;
}

export function getLateInterest() {
  return request<LateInterestOverview>(BASE);
}

export function updateLateInterestBase(base: AccrualBase) {
  return request<{ base: AccrualBase }>(`${BASE}/base`, {
    method: 'put',
    data: { base },
  });
}

export function createLateInterestRate(body: LateInterestPayload) {
  return request<LateInterestRateItem>(BASE, { method: 'post', data: body });
}

export function updateLateInterestRate(id: number, body: LateInterestPayload) {
  return request<LateInterestRateItem>(`${BASE}/${id}`, {
    method: 'put',
    data: body,
  });
}

export function deleteLateInterestRate(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
